import { Unreachable } from '@lemon8/web-app-shared/util';
import { atom } from 'jotai';
import { $SharingCurrentTraffic, IPOICurrentTraffic } from 'shared/atoms';
import { EPageType } from 'shared/constant';

export const $CurrentPOIId = atom((get) => {
  const traffic = get($SharingCurrentTraffic);
  const { pageType } = traffic;

  if (pageType !== EPageType.POI) {
    Unreachable(`invalid page type: ${pageType}`);
  }

  const userTraffic = traffic as IPOICurrentTraffic;

  return userTraffic.poiId;
});
